import Breadcrumbs from '../../CustomControls/Breadcrumb';
import { Button, Card, CardBody, Col, Container, Row, Table } from 'reactstrap';
import DatePicker from '../../CustomControls/CustomDatePicker';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFirstDateOfLastMonth, getLastDateOfLastMonth } from '../../../utils';
import { getAllRptDeptSummaryData, getCSVReport, setOnCleanUp } from '../../../store/actions/ReportOperation/rptDepartmentSummary';
import LoadingSpinner from '../../CustomControls/Spinner';
import Papa from 'papaparse';
import { initialRptDeptSummaryState } from '../../../store/reducers/initialReportState';

const DepartmentSummaryCSV = () => {
  const dispatch = useDispatch();
  const [filterFromDate, setFilterFromDate] = useState({ field: 'fromdate', value: getFirstDateOfLastMonth(), label: '' });
  const [filterToDate, setFilterToDate] = useState({ field: 'todate', value: getLastDateOfLastMonth(), label: '' });
  const rptData = useSelector(state => state.rptDeptSummary);
  const isLoading = rptData.isLoading || false;
  const csvRptData = useSelector(state => state?.rptDeptSummary?.csvDataDep);
  const [csvData, setCsvData] = useState();
  useEffect(() => {

    setCsvData(csvRptData);
  }, [csvRptData]);
  const reportHeading = 'Department Summary';
  const setLocalCleanUpData = cleanUpData => {
    dispatch(setOnCleanUp(cleanUpData))
}

//clean up
useEffect(() => {
  return () => {
        setLocalCleanUpData({
            data: { ...initialRptDeptSummaryState, csvDataDep: [] }
        })
    };
}, []);
  useEffect(() => {
    dispatch(getAllRptDeptSummaryData(rptData.filterOptions.filterBy, rptData.filterOptions.sortBy, true));
  }, []);

  const breadCrumbPaths = [
    { id: 1, title: 'Home', path: '/' },
    { id: 2, title: `${reportHeading} CSV`, path: '/operation-reports/department-summary-csv', isCurrent: true }
  ];

  const handleDateInput = (field, dateVal, callSetMethod) => {
    const saveObj = {};
    const setDate = dateVal ? new Date(dateVal) : null;
    saveObj.value = setDate;
    saveObj.field = field;
    saveObj.label = '';
    callSetMethod(saveObj);
  };

  const onGenerateHandler = () => {
    dispatch(getCSVReport(new Date(filterFromDate.value), new Date(filterToDate.value)));
  };
  const downloadCsv = () => {
    const csvContent = Papa.unparse(csvData);
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'data.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  return isLoading ? (
    <LoadingSpinner />
  ) : (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={`${reportHeading} CSV`} paths={breadCrumbPaths} />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <Row className="mb-2 buttonrow">
                    <Col sm="2">
                      <div className="mb-4">
                        <DatePicker
                          label="From Date"
                          selected={filterFromDate.value}
                          onChange={date => handleDateInput('fromdate', date, setFilterFromDate)}
                          dateFormat="dd-MMM-yyyy"
                        />
                      </div>
                    </Col>
                    <Col sm="2">
                      <div className="mb-4">
                        <DatePicker
                          label="To Date"
                          selected={filterToDate.value}
                          onChange={date => handleDateInput('todate', date, setFilterToDate)}
                          dateFormat="dd-MMM-yyyy"
                          minDate={filterFromDate.value}
                        />
                      </div>
                    </Col>

                    <Col sm="5">
                      <div className="text-sm-end">
                        <Button type="button" className="btn btn-primary btn-block  app-add-button" onClick={onGenerateHandler}>
                          GENERATE
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  {csvData?.length > 0 && (
                    <>
                    <Row>
                        
                        <Col >
                          <Button  onClick={downloadCsv} type="button" className="btn btn-primary btn-block mb-3 mx-auto " >
                            Download CSV
                          </Button>
                        </Col>
                      </Row>
                      <div style={{overflowX: 'auto'}}>
                      
                      <Table>
                        <thead>
                          <tr>{csvData?.length > 0 && Object.keys(csvData[0]).map((header, index) => <th key={index}>{header}</th>)}</tr>
                        </thead>
                        <tbody>
                          {csvData?.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                              {Object.values(row).map((cell, cellIndex) => (
                                <td key={cellIndex}>{cell}</td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                    </>
                    
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DepartmentSummaryCSV;
